import { makeStyles } from "@mui/styles";
import { createTheme } from "@mui/material/styles";
const theme = createTheme();

const useTestIITStyles = makeStyles(() => ({
  container: {
    padding: 0,
    marginLeft: "auto",
    maxWidth: "100% !important",
  },
  header: {
    position: "fixed",
    marginLeft: "auto",
    top: 0,
    width: "100%",
    zIndex: 1000,
    backgroundColor: "white",
    borderBottom: "1px solid #ccc",
  },
  content: {
    display: "flex",
    // Default desktop: header ~150px tall
    marginTop: "150px",
    height: "calc(100vh - 150px)",
    overflow: "hidden",
    // Tablet portrait: header grows a bit; also add 36px for hamburger strip
    "@media (min-width:600px) and (max-width:899px)": {
      marginTop: "156px",  // 120px header + 36px strip
      height: "calc(100vh - 156px)",
    },
    // Mobile: tiny header + 36px strip; allow scrolling
    "@media (max-width:599px)": {
      marginTop: "144px",  // ~108px header + 36px strip
      height: "calc(100vh - 144px)",
      flexDirection: "column",
      overflow: "auto",
    },
    "@media (min-width: 800px) and (max-width: 898px)": {
      marginTop: "136px",  // 100px header + 36px strip
      height: "calc(100vh - 136px)",
    },
  },
  left: {
    flexGrow: 1,
    overflowY: "hidden",
    backgroundColor: "#f5f5f5",
    marginTop: "10px",
    "@media (max-width:599px)": {
      overflowY: "visible",
      marginTop: "0px",
    },
  },
  right: {
    transition: "width 0.3s ease",
    backgroundColor: "#fff",
  },
}));

export default useTestIITStyles;
